import t from"react";import{Container as e}from"./styles.js";import o from"./components/Body/Body.js";const r=({testId:r,quote:s})=>t.createElement(e,{"data-testid":r},t.createElement(o,{testId:r},s));export{r as default};
//# sourceMappingURL=PressReleaseQuote.js.map
